/* Quick search panel: drops down under the header instead of opening the full search page.
   Loaded by snippets/zr-quick-search.liquid on every page.
   Nothing on the site sends shoppers to the separate search page any more:
   - typing shows instant results (predictive search)
   - Enter, a suggestion, or "Show all results" loads the full result list inside the panel,
     24 at a time with "Load more" (data comes from templates/search.zrqs.liquid)
   - any link or form on the site that points at /search opens this panel instead.
   A "Best sellers" bar (rendered by the snippet into <template id="zrqs-bestsellers">) sits
   under the search box. */
(function () {
  if (window.__zrQuickSearch) return;
  window.__zrQuickSearch = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var searchPath = (root + 'search').replace(/\/+$/, '');
  var panel, backdrop, form, input, results, lastFocus, timer, controller;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency }).format(n);
    } catch (e) {
      return n.toFixed(2);
    }
  }

  function ssHeader() {
    return document.querySelector('[id*="__ss_header"] > div');
  }

  function headerBottom() {
    var max = 0;
    var els = document.querySelectorAll('[id*="__ss_header"] > div, .shopify-section-group-header-group');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.height > 0 && r.bottom > max) max = r.bottom;
    }
    return Math.max(0, Math.round(max));
  }

  function isSearchUrl(url) {
    var u;
    try { u = new URL(url, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    var p = u.pathname.replace(/\/+$/, '');
    if (p !== searchPath && p !== '/search') return null;
    return u;
  }

  function build() {
    backdrop = document.createElement('div');
    backdrop.className = 'zrqs-backdrop';
    backdrop.addEventListener('click', close);

    panel = document.createElement('div');
    panel.className = 'zrqs';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Search');
    panel.innerHTML =
      '<div class="zrqs__inner">' +
        '<form class="zrqs__form" action="' + root + 'search" method="get" role="search">' +
          '<label class="zrqs__label" for="zrqs-input">Search</label>' +
          '<input class="zrqs__input" id="zrqs-input" type="search" name="q" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" placeholder="SEARCH:" aria-controls="zrqs-results">' +
          '<button type="button" class="zrqs__close" aria-label="Close search">Close</button>' +
        '</form>' +
        '<div class="zrqs__results" id="zrqs-results" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    form = panel.querySelector('.zrqs__form');
    input = panel.querySelector('.zrqs__input');
    results = panel.querySelector('.zrqs__results');

    // Best sellers bar, directly under the search box.
    var bsTpl = document.getElementById('zrqs-bestsellers');
    if (bsTpl && bsTpl.content) results.parentNode.insertBefore(bsTpl.content.cloneNode(true), results);

    panel.querySelector('.zrqs__close').addEventListener('click', close);

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(suggest, 180);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(timer);
      var q = input.value.trim();
      if (q) loadAll(q, 1);
      input.blur();
    });

    results.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-zrqs]');
      if (!t) return;
      e.preventDefault();
      var action = t.getAttribute('data-zrqs');
      if (action === 'query') {
        input.value = t.getAttribute('data-q');
        loadAll(input.value.trim(), 1);
      } else if (action === 'all') {
        loadAll(input.value.trim(), 1);
      } else if (action === 'more') {
        loadAll(t.getAttribute('data-q'), parseInt(t.getAttribute('data-page'), 10));
      }
    });

    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function trapFocus(e) {
    var f = panel.querySelectorAll('a[href], button, input:not([type="hidden"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function position() {
    var top = headerBottom();
    panel.style.top = top + 'px';
    backdrop.style.top = top + 'px';
    panel.style.maxHeight = 'calc(100vh - ' + top + 'px)';
  }

  function open(q) {
    if (!panel) build();
    lastFocus = document.activeElement;
    var h = ssHeader();
    if (h) h.classList.add('onscroll'); // solid header while searching (the homepage header is see-through)
    position();
    document.documentElement.classList.add('zrqs-open');
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    if (q) {
      input.value = q;
      loadAll(q, 1);
    }
    setTimeout(function () { input.focus(); if (!q) input.select(); }, 30);
    window.addEventListener('resize', position);
    window.addEventListener('scroll', position, { passive: true });
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('zrqs-open');
    var h = ssHeader();
    if (h && window.scrollY < 20) h.classList.remove('onscroll');
    window.removeEventListener('resize', position);
    window.removeEventListener('scroll', position);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function card(p) {
    var img = p.image;
    var price = money(p.price);
    var from = p.price_max && parseFloat(p.price_max) > parseFloat(p.price);
    var compare = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
    return '<li class="zrqs__item"><a class="zrqs__card" href="' + esc(p.url) + '">' +
      '<span class="zrqs__media">' + (img ? '<img src="' + esc(img) + (img.indexOf('width=') > -1 ? '' : (img.indexOf('?') > -1 ? '&' : '?') + 'width=360') + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="zrqs__name">' + esc(p.title) + '</span>' +
      '<span class="zrqs__price">' + (from ? 'From ' : '') + esc(price) +
        (compare && !from ? ' <s>' + esc(money(p.compare_at_price_max)) + '</s>' : '') +
        (p.available === false ? ' <span class="zrqs__soldout">Sold out</span>' : '') +
      '</span></a></li>';
  }

  function renderSuggest(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [];
    var collections = r.collections || [];
    var queries = (r.queries || []).filter(function (x) { return x.text && x.text.toLowerCase() !== q.toLowerCase(); });
    var html = '';

    if (queries.length || collections.length) {
      html += '<div class="zrqs__links">';
      if (queries.length) {
        html += '<div class="zrqs__group"><p class="zrqs__heading">Suggestions</p><ul>';
        queries.slice(0, 4).forEach(function (x) {
          html += '<li><a href="#" data-zrqs="query" data-q="' + esc(x.text) + '">' + esc(x.text) + '</a></li>';
        });
        html += '</ul></div>';
      }
      if (collections.length) {
        html += '<div class="zrqs__group"><p class="zrqs__heading">Collections</p><ul>';
        collections.slice(0, 4).forEach(function (c) {
          html += '<li><a href="' + esc(c.url) + '">' + esc(String(c.title).split('/').pop().trim()) + '</a></li>';
        });
        html += '</ul></div>';
      }
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="zrqs__products"><p class="zrqs__heading">Products</p><ul class="zrqs__grid">';
      products.forEach(function (p) {
        html += card({
          title: p.title,
          url: p.url,
          image: (p.featured_image && p.featured_image.url) || p.image,
          price: p.price,
          price_max: p.price_max,
          compare_at_price_max: p.compare_at_price_max,
          available: p.available
        });
      });
      html += '</ul></div>';
      html += '<button type="button" class="zrqs__all" data-zrqs="all">Show all results for &ldquo;' + esc(q) + '&rdquo;</button>';
    }

    if (!products.length && !collections.length && !queries.length) {
      html += '<p class="zrqs__empty">No results for &ldquo;' + esc(q) + '&rdquo;</p>';
    }

    results.innerHTML = html;
  }

  function failed() {
    panel.classList.remove('is-loading');
    results.innerHTML = '<p class="zrqs__empty">Search isn&rsquo;t available right now. Please try again.</p>';
  }

  function suggest() {
    var q = input.value.trim();
    if (controller) controller.abort();
    if (!q) { results.innerHTML = ''; return; }
    controller = window.AbortController ? new AbortController() : null;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=10' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,vendor,tag';
    panel.classList.add('is-loading');
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        panel.classList.remove('is-loading');
        if (input.value.trim() === q) renderSuggest(q, d);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        failed();
      });
  }

  function loadAll(q, page) {
    if (!q) return;
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    var url = root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&view=zrqs&page=' + page;
    panel.classList.add('is-loading');
    var more = results.querySelector('[data-zrqs="more"]');
    if (more) more.disabled = true;
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        panel.classList.remove('is-loading');
        var items = (d.products || []).map(card).join('');
        var grid;
        if (page === 1) {
          var count = d.count || 0;
          if (!count) {
            results.innerHTML = '<p class="zrqs__empty">No results for &ldquo;' + esc(q) + '&rdquo;</p>';
            return;
          }
          results.innerHTML =
            '<div class="zrqs__products"><p class="zrqs__heading">' + count + (count === 1 ? ' result' : ' results') + ' for &ldquo;' + esc(q) + '&rdquo;</p>' +
            '<ul class="zrqs__grid">' + items + '</ul></div>';
          panel.scrollTop = 0;
        } else {
          grid = results.querySelector('.zrqs__grid');
          if (grid) grid.insertAdjacentHTML('beforeend', items);
        }
        var old = results.querySelector('[data-zrqs="more"]');
        if (old) old.parentNode.removeChild(old);
        if (d.pages && page < d.pages) {
          results.insertAdjacentHTML('beforeend',
            '<button type="button" class="zrqs__all" data-zrqs="more" data-q="' + esc(q) + '" data-page="' + (page + 1) + '">Load more</button>');
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        failed();
      });
  }

  // Any link to the search page, anywhere on the site, opens the panel instead.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (panel && panel.contains(a))) return;
    var u = isSearchUrl(a.href);
    if (!u) return;
    e.preventDefault();
    open(u.searchParams.get('q') || '');
  }, true);

  // Any other search form on the site (outside the search page itself) opens the panel too.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || (panel && panel.contains(f))) return;
    if (isSearchUrl(location.href)) return;
    if (!isSearchUrl(f.getAttribute('action') ? f.action : '')) return;
    var field = f.querySelector('[name="q"]');
    if (!field) return;
    e.preventDefault();
    open(String(field.value || '').trim());
  }, true);
})();
